
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_Role_URl, Delete_Role_URl, Role_URl, SINGLE_Role_URl, Update_Role_URl } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllRole = createAsyncThunk('GetRole', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        
        const response = await FetchData(Role_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllRoleSlice = createSlice({
    name: 'Role',
    initialState: {
        Role: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllRole.fulfilled, (state, action) => {
                state.Role = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllRole.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

// -- Async Thunk to Get User Profile --
export const GetSingleRole = createAsyncThunk('GetSingleRole', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(SINGLE_Role_URl, {roleId : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetSingleRoleSlice = createSlice({
    name: 'SingleRole ',
    initialState: {
        Role: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetSingleRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSingleRole.fulfilled, (state, action) => {
                state.Role = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetSingleRole.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

export const AddNewRole = createAsyncThunk('AddRole', async (body, { rejectWithValue }) => {
    
    try {
        const response = await FetchData(CREATE_Role_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Role Created successfully.')
           return 'ok' 
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateRple = createAsyncThunk('updateRole', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(Update_Role_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
           Toast('success', 'Role updated successfully.')
            
           return 'ok' 
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteRole = createAsyncThunk('deleteRole', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(Delete_Role_URl, {RoleID : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
           Toast('success', 'Role Deleted successfully.')
            
           return 'ok' 
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});





// -- Async Thunk to Get User Profile --
export const CheckSingleRolePermisson = createAsyncThunk('CheckRolePermission', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(SINGLE_Role_URl, {roleId : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const CheckSingleRolePermissonSlice = createSlice({
    name: 'Role Permission ',
    initialState: {
        Permisson: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(CheckSingleRolePermisson.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(CheckSingleRolePermisson.fulfilled, (state, action) => {
                state.Permisson = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(CheckSingleRolePermisson.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

export {
    GetAllRoleSlice,
    GetSingleRoleSlice,
    CheckSingleRolePermissonSlice
};
